import {
  widgetGridDimensionsForWidgetTypes,
  //GRID_SIZE
} from "../helpers/constants";
import { actionCreators as userActionCreators } from "./userActions";
//import { key } from "react-icons-kit/entypo";

/* TYPES */
const CONNECT_WIDGET2SENSOR = "CONNECT_WIDGET2SENSOR";
const DISCONNECT_WIDGET_FROM_SENSOR = "DISCONNECT_WIDGET_FROM_SENSOR";
const DISCONNECT_ALL_WIDGETS_FROM_DEVICE = "DISCONNECT_ALL_WIDGETS_FROM_DEVICE";
const ADD_WIDGET2DASHBOARD = "ADD_WIDGET2DASHBOARD";
//const UPDATE_WIDGET_BOUNDS = "UPDATE_WIDGET_BOUNDS";
const DELETE_WIDGET = "DELETE_WIDGET";
const MOVE_WIDGET_ORIGIN = "MOVE_WIDGET_ORIGIN";
const RESIZE_WIDGET = "RESIZE_WIDGET";
const SET_WIDGET_SETTINGS_PROP = "SET_WIDGET_SETTINGS_PROP";

/* WIDGET SETTINGS ACTION CREATORS */

const setWidgetSettingsProp = (widgetid, key, val) => {
  return dispatch => {
    dispatch({
      type: SET_WIDGET_SETTINGS_PROP,
      widgetid,
      key,
      val
    });
    dispatch(userActionCreators.persistWidgetConfig());
  };
};

const connectWidgetToSensor = (deviceid, sensorid, widgetid, widgetslot) => {
  console.log("connectWidgetToSensor action creator called");
  return dispatch => {
    dispatch({
      type: CONNECT_WIDGET2SENSOR,
      deviceid,
      sensorid,
      widgetid,
      widgetslot
    });
    dispatch(userActionCreators.persistWidgetConfig());
  };
};

const disconnectWidgetFromSensor = (widgetid, sensorid) => {
  console.log("disconnectWidgetFromSensor action creator called");
  return dispatch => {
    dispatch({
      type: DISCONNECT_WIDGET_FROM_SENSOR,
      sensorid,
      widgetid
    });
    dispatch(userActionCreators.persistWidgetConfig());
  };
};

const disconnectAllWidgetsFromDevice = (deviceid) => {
  console.log("disconnectAllWidgetsFromDevce action creator called");
  return {
    type: DISCONNECT_ALL_WIDGETS_FROM_DEVICE,
    uid: deviceid
  }
}

const addWidgetToDashboard = (
  widget_type,
  gridOrigin = undefined,
  widgetid
) => {
  console.log("addWidgetToDashboard action creator called");
  return dispatch => {
    dispatch({
      type: ADD_WIDGET2DASHBOARD,
      widget_type,
      widgetid,
      gridOrigin,
      gridDimensions: widgetGridDimensionsForWidgetTypes[widget_type]
    });
    dispatch(userActionCreators.persistWidgetConfig());
  };
};

const deleteWidget = widgetid => {
  return dispatch => {
    dispatch({
      type: DELETE_WIDGET,
      widgetid
    });
    dispatch(userActionCreators.persistWidgetConfig());
  };
};

const moveWigetOrigin = (newGridOrigin, widgetid, persist) => {
  return dispatch => {
    dispatch({
      type: MOVE_WIDGET_ORIGIN,
      widgetid,
      gridOrigin: newGridOrigin
    });
    persist && dispatch(userActionCreators.persistWidgetConfig());
  };
};

const resizeWidget = (targetGridCoords, side, widgetid, persist) => {
  return dispatch => {
    dispatch({
      type: RESIZE_WIDGET,
      targetGridCoords,
      widgetid,
      side
    });
    persist && dispatch(userActionCreators.persistWidgetConfig());
  };
};

/* EXPORTS */
export const actionsTypes = {
  CONNECT_WIDGET2SENSOR,
  DISCONNECT_WIDGET_FROM_SENSOR,
  DISCONNECT_ALL_WIDGETS_FROM_DEVICE,
  ADD_WIDGET2DASHBOARD,
  DELETE_WIDGET,
  MOVE_WIDGET_ORIGIN,
  RESIZE_WIDGET,
  SET_WIDGET_SETTINGS_PROP
};
export const actionCreators = {
  connectWidgetToSensor,
  disconnectWidgetFromSensor,
  disconnectAllWidgetsFromDevice,
  addWidgetToDashboard,
  deleteWidget,
  moveWigetOrigin,
  resizeWidget,
  setWidgetSettingsProp
};
